import { render } from "./DateInput.vue?vue&type=template&id=3336855d&lang=pug"
import script from "./DateInput.vue?vue&type=script&lang=ts"
export * from "./DateInput.vue?vue&type=script&lang=ts"
script.render = render

export default script